import { css, useTheme } from '@fable/theme'
import { OverflowMenu } from '../OverflowMenu'
import { useState } from 'react'
import { FlexBox, Icon, Text } from '@fable/components'
import { CompChildren } from '@fable/types'
import { useStatsTheme } from '../../../theme/ctx'

interface Props {
  text: string | CompChildren
}

export const StatsProfileBoxInfo = ({ text }: Props) => {
  const [open, setOpen] = useState(false)
  const { colors } = useTheme()
  const theme = useStatsTheme((s) => s.theme)

  return (
    <OverflowMenu
      wrapperStyles={css`
        top: 32px;
        left: 0;
      `}
      open={open}
      setOpen={setOpen}
      icon="info"
      size="S"
      trigger={
        <Icon
          type="info-solid"
          className={css`
            width: 14px;
          `}
          fill={theme.colors.section.textSecondary}
        />
      }
      free
    >
      <FlexBox
        className={css`
          padding: 0 12px;
        `}
        flexDirection="column"
      >
        <Icon
          className={css`
            margin-bottom: 4px;
            width: 20px;
          `}
          type="info"
          fill={colors.uiPewterGrey}
        />
        <Text type="body" sizing="M" color={colors.uiWhite}>
          {text}
        </Text>
      </FlexBox>
    </OverflowMenu>
  )
}
